import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectIsFirstFloor = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('is_first_floor')(jsonQuery),
);
